import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import { Menu, Modal, Dropdown } from "antd";
import {
  LogoutOutlined,
  LoginOutlined,
  MenuOutlined,
  DownOutlined,
  GlobalOutlined,
} from "@ant-design/icons";

import * as authActions from "modules/auth/actions";
import { clearFlashMessage, removeUIState } from "modules/ui/actions";
import { translate } from "lib/helper";
import {
  StyledHearder,
  MenuHeader,
  StyledImageHeader,
} from "styled/common-styled";
import SliderBar from "./SliderBar";

const MenuItemGroup = Menu.ItemGroup;

// ปุ่มสลับภาษาแสดงชื่อภาษาปลายทางด้วยภาษานั้นเอง จึงไม่อยู่ใน dictionary (ค่าใน en ห้ามมีตัวอักษรไทย)
const LANGUAGE_NAMES = { th: "ภาษาไทย", en: "English" };
const PROFILE_MENU_ID = "header-profile-menu";

class Header extends Component {
  state = {
    notiCount: 0,
    haveNewNoti: false,
    inputLng: "",
    token: "",
    collapsed: true,
    profileOpen: false,
  };

  profileButton = React.createRef();

  _isMounted = false;

  onRemoveCredentials = () => {
    this.props.removeCredentials();
    this.props.removeUIState();
  };

  onDismiss = () => {
    this.props.clearFlashMessage();
  };

  componentDidMount() {
    this._isMounted = true;
    let self = this;
    let { tokenExp } = this.props;
    let timeNow = Date.now();

    if (Math.floor(timeNow / 1000) < tokenExp) {
      let diffTime = (tokenExp - Math.floor(timeNow / 1000)) * 1000;
      this.tokenExpTimeout = setTimeout(function () {
        // Modal.warning render นอก LangContext จึงต้องส่งข้อความเป็น string ตามภาษาตอนที่ token หมดอายุ
        const lang = self.props.langBtn === "en" ? "en" : "th";
        self.modal(
          translate("notification", "header", lang),
          translate("tokenExpired", "header", lang)
        );
      }, diffTime);
    }

    this.setState({
      inputLng: this.props.langBtn === "en" ? "us" : "th",
    });
  }

  setToken(token) {
    this.setState({
      ...this.state,
      token,
    });
  }

  componentWillUnmount() {
    this._isMounted = false;
    clearInterval(this.tokenExpTimeout);
  }

  checkSelectLang = (inputLng) => {
    this.props.changeLang(inputLng);
    if (inputLng === "en") {
      this.setState({
        inputLng: "us",
      });
    } else {
      this.setState({
        inputLng: "th",
      });
    }
  };

  // เมนูโปรไฟล์แบบ menu button: เปิดแล้วย้าย focus เข้าเมนู ลูกศรขึ้น/ลงเลือก Enter กด
  // Esc หรือ Tab ปิดเมนูแล้วคืน focus ให้ปุ่มโปรไฟล์
  onProfileOpenChange = (open) => {
    this.setState({ profileOpen: open });
    if (open) this.focusProfileMenu();
  };

  focusProfileMenu = () => {
    let tries = 0;
    const focusMenu = () => {
      const menu = document.getElementById(PROFILE_MENU_ID);
      if (menu) {
        menu.focus({ preventScroll: true });
      } else if (tries < 10) {
        tries += 1;
        window.requestAnimationFrame(focusMenu);
      }
    };
    window.requestAnimationFrame(focusMenu);
  };

  closeProfileMenu = (returnFocus) => {
    this.setState({ profileOpen: false });
    if (returnFocus && this.profileButton.current) {
      this.profileButton.current.focus();
    }
  };

  onProfileMenuKeyDown = (e) => {
    if (e.key === "Escape" || e.key === "Tab") {
      e.preventDefault();
      this.closeProfileMenu(true);
    } else if (e.key === "Enter") {
      // rc-menu ยังได้ keydown นี้ไปกด item ตามปกติ แต่กันไม่ให้ browser ส่ง keypress ต่อ
      // เพราะ focus คืนไปที่ปุ่มโปรไฟล์แล้ว keypress จะไปคลิกปุ่มนั้นจนเมนูเปิดซ้ำ
      e.preventDefault();
    }
  };

  onSwitchLang = () => {
    this.checkSelectLang(this.props.langBtn === "en" ? "th" : "en");
    this.closeProfileMenu(true);
  };

  modal = (title, content) => {
    this.onRemoveCredentials();
    Modal.warning({
      title: title,
      okText: "Ok",
      okType: "default",
      onOk() {},
      content: content,
    });
  };

  toggle = () => {
    this.setState({
      collapsed: !this.state.collapsed,
    });
  };

  getProfile = () => {
    try {
      return JSON.parse(localStorage.getItem("profile")) || {};
    } catch (e) {
      return {};
    }
  };

  render() {
    const { done } = this.props;
    const profile = this.getProfile();
    const username = profile.username || "";
    const fullName =
      [profile.firstname, profile.lastname].filter(Boolean).join(" ") ||
      profile.name ||
      username;
    const initial = (fullName || "?").trim().charAt(0);
    const nextLang = this.props.langBtn === "en" ? "th" : "en";

    const profileMenu = (
      <MenuHeader
        id={PROFILE_MENU_ID}
        onClick={() => this.setState({ profileOpen: false })}
        onKeyDownCapture={this.onProfileMenuKeyDown}
      >
        <MenuItemGroup
          title={
            <div className="profile-info">
              <div className="profile-name">{fullName}</div>
              <div className="profile-username">
                {translate("titleAccount", "header")}: {username}
              </div>
            </div>
          }
        >
          <Menu.Item
            key="menu:lang"
            className="lang-item"
            data-cy="switch-language"
            onClick={this.onSwitchLang}
          >
            <GlobalOutlined /> <span lang={nextLang}>{LANGUAGE_NAMES[nextLang]}</span>
          </Menu.Item>
          {done ? (
            <Menu.Item
              key="menu:1"
              className="logout-item"
              onClick={this.onRemoveCredentials}
            >
              <Link data-cy="logout" to="/">
                <LogoutOutlined /> {translate("logout", "header")}
              </Link>
            </Menu.Item>
          ) : (
            <Menu.Item key="menu:1">
              <Link to="/">
                <LoginOutlined /> {translate("login", "header")}
              </Link>
            </Menu.Item>
          )}
        </MenuItemGroup>
      </MenuHeader>
    );

    return (
      <Fragment>
        <StyledHearder>
          <div className="space-between-middle" style={{ height: "100%" }}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <StyledImageHeader>
                <img src={"/img/smartquality2-web-red.png"} alt="SmartQuality" />
              </StyledImageHeader>
              <div className="header-divider" />
              <button
                type="button"
                className="header-menu-trigger"
                onClick={this.toggle}
              >
                <MenuOutlined /> {translate("menu", "sis")}
              </button>
            </div>
            <Dropdown
              overlay={profileMenu}
              trigger={["click"]}
              placement="bottomRight"
              visible={this.state.profileOpen}
              onVisibleChange={this.onProfileOpenChange}
              // สร้างเมนูใหม่ทุกครั้งที่เปิด: rc-menu จำ item ที่ hover ค้างไว้ ลูกศรลงครั้งแรกจะข้ามไป logout
              destroyPopupOnHide
            >
              <button
                type="button"
                className="header-profile"
                data-cy="user-info"
                aria-haspopup="menu"
                aria-expanded={this.state.profileOpen}
                ref={this.profileButton}
              >
                <span className="header-avatar">{initial}</span>
                <span className="header-username">{fullName}</span>
                <DownOutlined style={{ fontSize: "10px", opacity: 0.8 }} />
              </button>
            </Dropdown>
          </div>
        </StyledHearder>

        <SliderBar
          toggle={this.toggle}
          collapsed={this.state.collapsed}
          profile={this.props.profile}
        />
      </Fragment>
    );
  }
}

const mapStateToProps = ({
  auth: { accessToken, done, profile, tokenExp },
  ui: { flash, lastestNotificationAt },
}) => ({
  accessToken,
  done,
  profile,
  flash,
  lastestNotificationAt,
  tokenExp,
});
const mapDispatchToProps = {
  removeCredentials: authActions.removeCredentials,
  removeUIState: removeUIState,
  loadCredentials: authActions.loadCredentials,
  clearFlashMessage: clearFlashMessage,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Header));
